import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import { createStore } from 'vuex'
import { setupAxiosInterceptors } from './utils/axiosInterceptor'
import { setupMicrofrontendListener } from './utils/microfrontendListener'

// Configurar interceptores de axios para detección automática de tokens expirados
setupAxiosInterceptors()

// Global fallback: catch ChunkLoadErrors that slip through router.onError()
// (happens when webpack rejects the dynamic-import promise outside an active navigation)
;(function installChunkErrorHandler() {
  const RELOAD_KEY = 'chunk_reload_attempted'

  function isChunkError(err) {
    if (!err) return false
    return (
      err.name === 'ChunkLoadError' ||
      /loading chunk \d+ failed/i.test(err.message || '') ||
      /loading css chunk \d+ failed/i.test(err.message || '')
    )
  }

  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkError(event.reason)) return
    event.preventDefault()
    if (sessionStorage.getItem(RELOAD_KEY)) {
      // Already reloaded once — avoid infinite loop
      sessionStorage.removeItem(RELOAD_KEY)
      return
    }
    sessionStorage.setItem(RELOAD_KEY, '1')
    window.location.reload()
  })
})()

// Configurar listener para comunicación con microfrontends (detección de token expirado)
setupMicrofrontendListener()

const store = createStore({
  state: {
    currentUser: {
      name: '',
      token: ''
    }
  },
  getters: {
    user (state) {
      return state.currentUser
    }
  },
  mutations: {
    loginUser (state, newUser) {
      if (newUser.name !== '' && typeof newUser.name === 'string') {
        state.currentUser = newUser
      }
    }
  }
})

const app = createApp(App).use(router).use(store)
app.mount('#app')
